angular.module('am4').factory('apiUrl', function(config) {
    return config.apiUrl;
});



// WEBPACK FOOTER //
// ./src/app/services/apiUrl.js